import { Component } from '@angular/core';
import { ReportManagementService } from '../../services/report-management.service';
import { SpecificationUi } from '../models/specification-ui.model';

@Component({
    selector: 'app-specification-adjustments',
    templateUrl: './specification-adjustments.component.html',
    styleUrls: [ './specification-adjustments.component.scss' ]
})

export class SpecificationAdjustmentsComponent {
    specs: Array<SpecificationUi> = new Array<SpecificationUi>();
    categories: any;
    specCategories = [
        { name: 'Drive Train',   isOpen: false, filter: 1 },
        { name: 'Fuel Delivery', isOpen: false, filter: 2 },
        { name: 'Fuel Type',     isOpen: false, filter: 3 },
        { name: 'Transmission',  isOpen: false, filter: 4 }
    ];

    constructor(private reportManagementService: ReportManagementService) {
        this.reportManagementService.verifyAdjustmentsAccess();
        this.reportManagementService.onSpecificationUpdated.subscribe(data => {
            this.specs = data;
        });
        this.reportManagementService.getAllSpecifications();
        const categories: any = this.reportManagementService.specCategories;

        categories.forEach(element => {
            if (element.name === 'HGVs' || element.name === 'Bikes') {
                element.hidden = true;
            } else {
                element.hidden = false;
                element.categories = this.specCategories.map(x => Object.assign({}, x));
            }
        });
        this.categories = categories;
    }

    onChange() {
        this.reportManagementService.specification = this.specs;
    }
}



// WEBPACK FOOTER //
// ./src/app/report/adjustments/components/specification-adjustments.component.ts